<template>
  <div v-if="hasB2cOrg && userName" class="middle-container">
    <div class="ml-4 mb-14">
      <b-headline type="h4" typography="h4" class="text-left" v-html="$t('headline')" />
      <div>
        <label class="text-mid-grey font-bold" v-html="$t('name')" />:
        <span class="text-dark-grey">
          {{ userName }}
        </span>
        <div class="mt-1">
          <a @click="triggerModalOpen" class="blinkist-account__link">
            {{ $t("changeName") }}
          </a>
        </div>
      </div>
    </div>
    <change-name-modal :name="userName" @submit="submitNameChange" />
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import events from "@/bl-events/index"
import ChangeNameModal from "@/features/settings/components/modals/change-name-modal"
import { mapState } from "vuex"

export default {
  name: "PersonalInformation",
  components: {
    BHeadline,
    ChangeNameModal
  },
  data: () => ({
    loading: false,
    name: null
  }),
  computed: {
    ...mapState("multiUserPlanManagement", ["hasB2cOrg", "userName"])
  },
  mounted() {
    this.fetchUserName()
  },
  methods: {
    fetchUserName() {
      this.$store.dispatch("multiUserPlanManagement/fetchUserName")
    },
    submitNameChange(newName) {
      this.$store.dispatch("multiUserPlanManagement/triggerNameChange", newName)
    },
    triggerModalOpen() {
      events.emit("modal:change-name-modal:open")
    }
  },
  i18n: {
    messages: {
      en: {
        name: "Name",
        headline: "Personal information",
        changeName: "Edit name",
        nameChanged: "Name was successfully changed"
      },
      de: {
        name: "Name",
        headline: "Mach deine Einladung persönlicher",
        changeName: "Name ändern",
        nameChanged: "Name was successfully changed"
      }
    }
  }
}
</script>
